import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../api/client.jsx';
import { useApiMutation } from '../../api/mutations';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';
import { sendersFixture } from './fixture';

/**
 * #561 Outbound-Absender-Management. Backend: orbit-backend BFF (#282) →
 * spam-api Admin-API (#559):
 *   GET    /v1/spam/outbound/senders
 *   PUT    /v1/spam/outbound/senders/:key/override   { manual_hourly_cap?, exempt?, note? }
 *   DELETE /v1/spam/outbound/senders/:key/override
 */
export function useOutboundSenders() {
  const { fetch } = useApiClient();
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['spam-outbound-senders', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return sendersFixture(); }
      return fetch('/v1/spam/outbound/senders?limit=200');
    },
    staleTime: 15_000,
  });
}

export function useSetOverride() {
  return useApiMutation({
    live: (fetch, { key, body }) => fetch(
      `/v1/spam/outbound/senders/${encodeURIComponent(key)}/override`,
      { method: 'PUT', body },
    ),
    fixture: () => ({ ok: true }),
    invalidate: ['spam-outbound-senders'],
    successMessage: () => 'Override gespeichert.',
  });
}

export function useClearOverride() {
  return useApiMutation({
    live: (fetch, { key }) => fetch(
      `/v1/spam/outbound/senders/${encodeURIComponent(key)}/override`,
      { method: 'DELETE' },
    ),
    fixture: () => ({ ok: true }),
    invalidate: ['spam-outbound-senders'],
    successMessage: () => 'Override entfernt.',
  });
}
